/**
 * React Islands Registry
 *
 * This file centralizes the registration of all React island components.
 * Each island component exports a config object that defines how it should be mounted.
 *
 * To add a new island:
 * 1. Create your component in src/islands/
 * 2. Export a config object with the required properties
 * 3. Import and register it here
 */

import { AnnouncementBarConfig } from "./announcement-bar/AnnouncementBar";
import { ExampleIslandConfig } from "./ExampleIsland";
import { HamburgerMenuConfig } from "./hamburger-menu/HamburgerMenu";
import { HeaderMenuConfig } from "./header-menu/HeaderMenu";
import { SubscriptionFormConfig } from "./subscription-form/SubscriptionForm";

export interface IslandConfig {
  key: string;
  component: React.ComponentType<any>;
}

export const islandRegistry: IslandConfig[] = [
  AnnouncementBarConfig,
  ExampleIslandConfig,
  HamburgerMenuConfig,
  HeaderMenuConfig,
  SubscriptionFormConfig,
];
